// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { autocompleteSearch } from "@insite/client-framework/Services/AutocompleteService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";

// XNG-Changes: PPSC-1314 hawk search to instant engage
export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    if (props.apiParameter.query === "" && !props.apiResult) {
        props.apiResult = await autocompleteSearch(props.apiParameter);
    }
};

addToChainAfter(chain, RequestDataFromApi, XngRequestDataFromApi);
